/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const Confidence = {
    High: 'high',
    Medium: 'medium',
    Low: 'low',
} as const;
export type Confidence = typeof Confidence[keyof typeof Confidence];


export function instanceOfConfidence(value: any): boolean {
    for (const key in Confidence) {
        if (Object.prototype.hasOwnProperty.call(Confidence, key)) {
            if (Confidence[key as keyof typeof Confidence] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ConfidenceFromJSON(json: any): Confidence {
    return ConfidenceFromJSONTyped(json, false);
}

export function ConfidenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Confidence {
    return json as Confidence;
}

export function ConfidenceToJSON(value?: Confidence | null): any {
    return value as any;
}

export function ConfidenceToJSONTyped(value: any, ignoreDiscriminator: boolean): Confidence {
    return value as Confidence;
}

